import React from "react";
import CountUp from "react-countup";
import ArtworkCard from "./ArtworkCard";

function Share(props) {
  // console.log(props.gameData)
  return (
    <div className="w-100 h-100 absolute top-0 left-0 flex items-center justify-start flex-column">
      <div className="flex flex-column items-center w-90 tc">
        <p className="f3 ma0 pa0 mt6">{props.i18n.i_scored}</p>
        <p className="f1 mt1 mb3 pa0">
          <CountUp delay={0.5} end={Math.round(props.score)} duration={1} />{" "}
          points
        </p>
        <p className="f3 ma0 pa0">{props.i18n.playing_geoartwork}</p>
        <p className="f5 ma0 pa0 mt4">{props.i18n.can_you_beat_me}</p>
        <button
          className="mt3 mb3 bg-custom custom-light"
          onClick={() => {
            props.resetGame();
          }}
        >
          {props.i18n.try_it_yourself}
        </button>
      </div>
      <div className={"flex flex-column items-center justify-start w-90"}>
        <p className="f3 ma0 pa0 w-80 tc mt5 mb3">{props.i18n.check_my_collection}</p>
        <div className="w-100 flex flex-wrap justify-start-ns justify-center">
          {Array.from({ length: props.gameData.length }, (_, i) => (
            <div className="w-third-l w-50-m w-80 pl2 pr2" key={i}>
              <ArtworkCard
                gameData={props.gameData}
                round={i}
                displayMoreInfo={null}
                key={i}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Share;
